import { pdf } from "@react-pdf/renderer";
import InvoiceDocument from "../components/invoices/InvoiceDocument";

export const downloadInvoicePdf = async (booking) => {
  const blob = await pdf(<InvoiceDocument booking={booking} />).toBlob();

  const customerName = booking.customerName
    .toUpperCase()
    .replace(/\s+/g, "_")
    .replace(/[^A-Z_]/g, "");

  const dateObj = new Date(booking.bookingDate);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");

  const fileName = `INV-${customerName}_${day}_${month}_${booking.bookingId}.pdf`;

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
};
